import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { goPopup } from 'Store/actions/portalModalActions';
import * as actionLayer from '../../modules/AccountActions';
import ChangeLanguage from './ChangeLanguage';

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => dispatch(goPopup('')),
  ...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
  ...stateProps,
  actions: dispatchProps,
}))(ChangeLanguage);
